import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "row" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.content, (tContent) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
                key: tContent.member
            }, [
                (tContent.isVisible)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$forms.componentElementName(tContent.elementType)), {
                        key: 0,
                        schema: _ctx.schema,
                        content: tContent,
                        data: _ctx.data,
                        onCommand: _ctx.onCommand
                    }, null, 8, ["schema", "content", "data", "onCommand"]))
                    : _createCommentVNode("", true)
            ], 64));
        }), 128))
    ]));
}
